export default class Authorization {

    static getUrlRedirect(): string {
        return '/auth';
    }

    static redirectUrl() {
        window.location.replace(this.getUrlRedirect());
    }
}